module.exports = __webpack_public_path__ + "img/ybu.8a62898a.png";